import Location from "./location";
import ApiKeys from "./apiKeys";
import Utility from "../helpers/utility";
import { MINIAPP } from "../helpers/paymentConstants";
import store from "../store/index";
import LocalStorageFunc from "../helpers/localStorageFunc";

const { getPWAConfig } = require("web-vault");

const headers = (payload , addtionalHeader = false) => {
  let isMiniApp = Utility.getMiniAppStorageVal();
  isMiniApp = [MINIAPP.GPAY, MINIAPP.PAYTM].includes(isMiniApp) && isMiniApp;
  const apiKey = isMiniApp
    ? getPWAConfig("INDIA")[window._siteProps_?.props?.build_env_var][`${isMiniApp}_API_KEY`]
    : ApiKeys.DOMINO_API_KEY;
  const clientType = isMiniApp
    ? getPWAConfig("INDIA")[window._siteProps_?.props?.build_env_var][`${isMiniApp}_CLIENT_TYPE`]
    : "web app-chrome";
  let headers = {
    api_key: apiKey,
    client_type: clientType,
  };

  let credentials = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
    : "";
 
  let value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers
    : "";

  const regex = /[\{\}]/;   
  if (value && !value.isLoggedIn) {
    if (credentials) {
      for (const [key, val] of Object.entries(credentials)) {
        headers[key.toLowerCase()] = val;
      }
      if (credentials?.accessKeyId && !regex.test(credentials?.accessKeyId)) {
        headers["authtoken"] = credentials.accessKeyId;
      }
    }
  } else {
    if (credentials?.accessKeyId && !regex.test(credentials?.accessKeyId)) {
      headers["authtoken"] = credentials.accessKeyId;
    }
  }

  if (value && value.isLoggedIn) {
    headers["isloggedin"] = true;
  } else {
    headers["isloggedin"] = false;
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.userId
    : "";
  if (value) {
    headers["userid"] = value;
  }

  value = localStorage.lastLocationNew
    ? Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent
        ?.advanceOrderStoreId || Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent
        ?.id
    : "";
  if (value) {
    headers["storeid"] = value;
  } else {
    let __ = localStorage.storeId || "";
    if (__) {
      headers["storeid"] = __;
    } else {
      headers["storeid"] = Location.defaultStoreId;
      localStorage.storeId = Location.defaultStoreId;
    }
  }
  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.cartId
    : "";
  if (value) {
    headers["cartid"] = value;
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType
    : "";
  if (value) {
    headers["deliverytype"] = value;
  }

  if (payload && payload.withRefreshToken) {
    value = localStorage.userInfo
      ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
          ?.refreshToken
      : "";
    if (value) {
      headers["refreshtoken"] = value;
    }
  }

  if(addtionalHeader){
    const temp  = {
      ...headers ,
      ...payload.addtionalHeader,
    }

    headers = temp;
  }

  const childStoreId = store.state.Location.childStoreId || localStorage.getItem("CHILD_STORE_ID_IS");
  if(
    headers["deliverytype"] == 'D' &&
    childStoreId != undefined &&
    childStoreId != "undefined" && 
    childStoreId != "null" &&
    childStoreId ){
    headers["childStoreId"] = childStoreId;
  }

  const userLocationData = LocalStorageFunc.getUserLocationData();

  const { latitude = "" , longitude = ""} = userLocationData?.location || {};
  headers["u_lat"] = latitude;
  headers["u_long"] = longitude;

  if (headers?.accesskeyid && regex.test(headers?.accesskeyid)) {
    delete headers.accesskeyid;
  }
  if (headers?.secretkey && regex.test(headers?.secretkey)) {
    delete headers.secretkey;
  }
  
  return headers;
};

export default headers;
